import copy from '../../demo/fixtures/w5/copy.json'
import { useDemoStore } from '../../demo/store'
import { Button, Modal } from '../../ui'
import { ProcessSteps } from '../analysis/ProcessSteps'
import { fillTemplate, type LiveTriggerEntry } from '../analysis/live'
import { useProcessRun } from '../analysis/useProcessRun'
import styles from './AutomationPage.module.css'

interface TriggerDetailDialogProps {
  entry: LiveTriggerEntry | null
  onClose: () => void
  onDone: (message: string) => void
}

export function TriggerDetailDialog({ entry, onClose, onDone }: TriggerDetailDialogProps) {
  const undo = useDemoStore((state) => state.undoW5Proposal)
  const { visibleSteps, running, run } = useProcessRun()

  const undoEntry = async () => {
    if (!entry) return
    const from = entry.what.match(/\$[\d,]+/)?.[0] ?? '原值'
    const wasRejected = entry.state === 'rejected'
    const vars = { obj: entry.object, undoWhat: wasRejected ? `撤回拒绝：${entry.what}` : entry.what, from }
    const completed = await run(copy.process.proposalUndo.map((step) => ({ label: fillTemplate(step.label, vars), detail: fillTemplate(step.detail, vars) })), copy.process)
    if (!completed) return
    undo(entry.id)
    onDone(wasRejected
      ? `已撤回你的拒绝：提案回到待你确认，${entry.object}的日预算上限仍是 ${from}`
      : `已撤销这次调整：${entry.object}的日预算上限恢复为 ${from}，提案回到待你确认`)
    onClose()
  }

  const canUndo = entry?.byUser && (entry.state === 'done' || entry.state === 'rejected')
  return (
    <Modal open={Boolean(entry)} title="触发详情" hint={entry ? `${entry.rule} · ${entry.at}` : undefined} onClose={running ? () => undefined : onClose} footer={<>{canUndo ? <Button variant="ghost" disabled={running} onClick={() => void undoEntry()}>撤销这次调整</Button> : null}<Button disabled={running} onClick={onClose}>完成</Button></>}>
      {entry ? <dl className={styles.detailGrid}><div><dt>对象</dt><dd>{entry.object}</dd></div><div><dt>命中值</dt><dd>{entry.hit ?? '记录时未保存命中值'}</dd></div><div><dt>动作</dt><dd>{entry.what}</dd></div><div><dt>结果</dt><dd>{entry.result ?? '记录时未保存结果'}</dd></div><div><dt>依据</dt><dd>{entry.basis ?? '记录时未保存依据'}</dd></div></dl> : null}
      {running ? <div className={styles.processSlot}><ProcessSteps steps={visibleSteps} /></div> : null}
    </Modal>
  )
}
